import { ReactNode } from 'react'
import { Response } from 'request-dot-js'

import { handleSuccessResponseWithMessage } from 'api/utils/handleSuccessResponseWithMessage'
import { handleErrorResponseWithMessage } from 'api/utils/handleErrorResponseWithMessage'

interface Arguments {
  errorMessage?: string | ReactNode
  successMessage?: string | ReactNode
}

export const handleResponseWithMessage = ({
  errorMessage = 'Something went wrong, please try again later.',
  successMessage = 'Success!',
}: Arguments = {}) => <T>(response?: Response<T>) => {
  handleSuccessResponseWithMessage(successMessage)(response)
  handleErrorResponseWithMessage(errorMessage)(response)

  return response
}
